import { createSlice } from '@reduxjs/toolkit';

import type { SeoData } from './types';

const initialState: SeoData = {} as SeoData;
const seoSlice = createSlice({
  name: 'seo',
  initialState: { data: initialState },
  reducers: {
    updateSeoData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { updateSeoData } = seoSlice.actions;
export const seoReducer = seoSlice.reducer;
export type SeoState = ReturnType<typeof seoSlice.reducer>;
